module.exports = __webpack_public_path__ + "img/prodpage_6.6b2e20ac.png";